import React from 'react';
import { type AcademicRefereeFormsProps } from './types';
import { AcademicRefereeForm } from './AcademicRefereeForm';
import { PAGE_COMMON_TEXT } from '../../lang';

export const AcademicRefereeForms: React.FunctionComponent<
  AcademicRefereeFormsProps
> = (props: AcademicRefereeFormsProps) => {
  const academicReferees = props.data ?? [];
  const hasAcademicReferees = academicReferees.length > 0;

  return (
    <div className="px-4">
      {hasAcademicReferees ? (
        <>
          {academicReferees.map((academicReferee, index) => {
            return (
              <AcademicRefereeForm
                key={index}
                academicRefereeIndex={index}
                academicReferee={academicReferee}
              />
            );
          })}
        </>
      ) : (
        <div>{PAGE_COMMON_TEXT.NA}</div>
      )}
    </div>
  );
};
